import React, { Component } from 'react';
import { BrowserRouter, Redirect, Route, Switch } from 'react-router-dom';
//import {  HashRouter, Route, Switch } from 'react-router-dom';
import { connect } from 'react-redux';
import * as actions from './../src/actions';
// Styles
// Import Font Awesome Icons Set
import 'font-awesome/css/font-awesome.min.css';
// Import Main styles for this application
import './scss/style.css'

// Containers
import { DefaultLayout } from './containers';
// Pages
import {
    Login,
    MasterScoreBoard,
    Page404,
    Page500
} from './views/Pages';
import SignUp from './views/Pages/SignUp/SignUp';
// import { 
//   MemberEntryDetail } from './views/Home';

class App extends Component {

    componentDidMount() {
        this.props.fetchUser();
    }

    render() {
        return (
            <div>
                {/* Brain of rounter */}
                <BrowserRouter>
                    <Switch>
                        {
                            this.props.auth.isAuth
                                ?
                                <div>
                                    <Route path="/" name="Home" component={DefaultLayout} />
                                </div>
                                :
                                <div>
                                    <Route exact path="/*" name="Login Page" component={Login} />
                                    <Route exact path="/login" name="Login Page" component={Login} />
                                </div>
                        }
                    </Switch>
                </BrowserRouter>
            </div>
        );
    }
}

function mapStateToProps(state) {
    return { auth: state.auth };
}


export default connect(mapStateToProps, actions)(App);
